import { useEffect } from 'react';

import { useLocation } from 'react-router';

import * as Sentry from '@sentry/react';

export default function AppVersionChecker() {
  const location = useLocation();

  useEffect(() => {
    checkVersionAndRefreshIfNeeded();
  }, [location]);

  const fetchRemoteVersion = async (): Promise<boolean> => {
    try {
      const timestamp = Date.now();
      const response = await fetch(`/version.json?t=${timestamp}`);
      const data = await response.json();

      if (data['version'] !== __APP_VERSION__) {
        return true;
      }
      return false;
    } catch (e: any) {
      Sentry.captureException(new Error(`Error fetching remote version: ${e.message}`));
      return false;
    }
  };

  const checkVersionAndRefreshIfNeeded = async () => {
    const refreshNeeded = await fetchRemoteVersion();
    if (refreshNeeded) {
      globalThis.location.reload();
    }
  };

  return null;
}
